import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const CloudUploadIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M4.896 9.207C5.456 5.752 8.414 3.1 12 3.1c3.586 0 6.543 2.652 7.104 6.107a6.403 6.403 0 0 1 2.796 5.307c0 3.514-2.807 6.386-6.3 6.386H8.4c-3.493 0-6.3-2.872-6.3-6.386 0-2.209 1.108-4.16 2.796-5.307ZM12.875 13v3.5h-1.75V13H8.5L12 9.5l3.5 3.5h-2.625Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M12.875 13v3.5h-1.75V13H8.5L12 9.5l3.5 3.5h-2.625Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M12 3.1c-3.586 0-6.543 2.652-7.104 6.107A6.403 6.403 0 0 0 2.1 14.514c0 3.514 2.807 6.386 6.3 6.386h7.2c3.493 0 6.3-2.872 6.3-6.386 0-2.209-1.108-4.16-2.796-5.307C18.544 5.752 15.586 3.1 12 3.1ZM6.628 9.833C6.908 7.051 9.218 4.9 12 4.9c2.783 0 5.093 2.151 5.372 4.933l.046.459.399.23a4.599 4.599 0 0 1 2.283 3.992c0 2.546-2.028 4.586-4.5 4.586H8.4c-2.472 0-4.5-2.04-4.5-4.586a4.6 4.6 0 0 1 2.283-3.991l.4-.231.045-.459Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `CloudUploadIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { CloudUploadIcon };
//# sourceMappingURL=CloudUploadIcon.mjs.map
